export enum Mode {
	USER = 'USER',

	ADMIN = 'ADMIN'
}
